var valinnat = {
	items: [],
};
var atcButton = document.getElementById('add-suositellut');
if(atcButton !== null) {
	atcButton.disabled = true;


var items = document.querySelectorAll('.atc-wrapper input');
[...items].forEach((item) => {
	item.checked = false;

	item.addEventListener('click', function (e) {
		var checked = item.getAttribute('data-checked');
		var productToAdd = item.parentElement;
		var productQty = Number(productToAdd.getAttribute('data-product-quantity'));
		var productID = Number(productToAdd.getAttribute('data-product-id'));

		if (checked === '0') {
			checked = '1';
			item.setAttribute('data-checked', '1');
			valinnat.items.push({
				quantity: productQty,
				id: productID,
			});
		} else {
			checked = '0';
			item.setAttribute('data-checked', '0');

			var index = valinnat.items
				.map((x) => {
					return x.Id;
				})
				.indexOf(productID);
			valinnat.items.splice(index, 1);
		}
		if (valinnat.items.length > 0) {
			atcButton.disabled = false;
		} else {
			atcButton.disabled = true;
		}
	});
});
atcButton.addEventListener('click', function () {
	var data = JSON.stringify(valinnat);
	fetch('/cart/add.js', {
		method: 'POST',
		body: data,
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
		},
	})
		.then((response) => response.json())
		.then(function (data) {
			if (data.status === 422) {
				this.error(data);
			} else {
				document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
				atcButton.disabled = true;

				[...items].forEach((item) => {
					var checked = item.getAttribute('data-checked');
					item.checked = false;
					item.setAttribute('data-checked', '0');
				});

				valinnat = {
					items: [],
				};
			}
		});
});
}